import { useContext } from "react";
import { __RouterContext } from "react-router";

// eslint-disable-next-line import/no-anonymous-default-export
export default () => useContext(__RouterContext);
